import React, { PropsWithChildren, useMemo } from "react";
import cx from "classnames";
import { leftHandNavId, transitionBaseClass } from "../../constants";

interface Props {
  visible: boolean;
  headerHeight?: number;
}

const LeftHandNav = ({
  visible,
  headerHeight = 60,
  children,
}: PropsWithChildren<Props>) => {
  const placeholderClass = cx("w-0 relative", transitionBaseClass, {
    "lg:w-[320px]": visible,
  });

  const navBarClass = cx(
    "w-full md:w-[320px] fixed bg-white border-r",
    "border-grey-light-2 z-[4] overflow-y-auto",
    transitionBaseClass,
    {
      "translate-x-0": visible,
      "-translate-x-full points": !visible,
    }
  );

  const navBarStyle = useMemo(
    () => ({
      height: `calc(100dvh - ${headerHeight}px)`,
    }),
    [headerHeight]
  );

  return (
    <div id={leftHandNavId} className={placeholderClass}>
      <div className={navBarClass} style={navBarStyle}>
        {children}
      </div>
    </div>
  );
};

export default LeftHandNav;
